import React, {PropsWithChildren, useContext, useEffect, useState} from "react";
import {Theme} from "../models/theme.model";
import {convertHexColorToRGB, convertRGBColorToHex, getContrastColor} from "../utils/util-functions";

interface ThemeState {
    theme: Theme;
    setTheme: (theme: Theme) => void;
}

export const ThemeContext = React.createContext({} as ThemeState);

export const ThemeProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const themeData: Theme = (window as any).THEME;
    const darkRGBTextColor = convertHexColorToRGB(themeData.text_dark_color);
    const lightRGBTextColor = convertHexColorToRGB(themeData.text_light_color);
    const brandingRBGColor = convertHexColorToRGB(themeData.branding_color);
    const brandingLightRBGColor = convertHexColorToRGB(themeData.branding_light_color);
    const contrastTextColor = getContrastColor(brandingRBGColor, lightRGBTextColor, darkRGBTextColor);
    const contrastLightTextColor = getContrastColor(brandingLightRBGColor, lightRGBTextColor, darkRGBTextColor);
    themeData.text_contrast_color = convertRGBColorToHex(contrastTextColor);
    themeData.text_light_contract_color = convertRGBColorToHex(contrastLightTextColor);

    const [theme, setTheme] = useState<Theme>(themeData);

    return (
        <ThemeContext.Provider value={{theme, setTheme}}>
            {children}
        </ThemeContext.Provider>
    )
}
